import { useCallback, useEffect, useState } from 'react'
import { listUsers } from '../services/users'

const EMPTY = {
  users: [],
  facets: { occupations: [], companies: [], schools: [] },
  truncated: false,
  requestCount: 0,
}

// Directory for the network sidebar. Search text waits briefly so typing does
// not fire a request per keystroke.
export function useUsers({ q = '', scope = 'all', occupation = [], company = [], school = [] } = {}) {
  const [data, setData] = useState(EMPTY)
  const [status, setStatus] = useState('loading')
  const [tick, setTick] = useState(0)
  const reload = useCallback(() => setTick((n) => n + 1), [])

  const occKey = occupation.join('\n')
  const companyKey = company.join('\n')
  const schoolKey = school.join('\n')

  useEffect(() => {
    let alive = true
    const timer = setTimeout(() => {
      listUsers({ q, scope, occupation, company, school })
        .then((next) => {
          if (!alive) return
          setData({
            users: next.users || [],
            facets: next.facets || EMPTY.facets,
            truncated: Boolean(next.truncated),
            requestCount: next.requestCount || 0,
          })
          setStatus('ready')
        })
        .catch(() => {
          if (alive) setStatus('error')
        })
    }, q ? 250 : 0)
    return () => {
      alive = false
      clearTimeout(timer)
    }
    // The joined keys stand in for the arrays so a new array identity does not refetch.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [q, scope, occKey, companyKey, schoolKey, tick])

  return { ...data, status, reload }
}
